import React, { useState } from "react";

// Jds
import {
  ActionButton,
  InputDate,
  InputField,
  Container,
  Text,
  InputCheckbox,
  InputTextarea,
  Button,
  InputRadio,
} from "@jds/core";

import useApiHttp from "../../../hooks/use-http";
import { useNavigate, useParams } from "react-router-dom";

export default function CancelEventForm(props) {
  const { closeModal } = props;
  const navigate = useNavigate();

  const formSubmitHandler = (e) => {
    e.preventDefault();
  };
  const [reasonLabel, setReasonLabel] = useState([
    "Change in Plans",
    "Unexpected Circumstances",
    "Venue Issues",
    "Low Attendance",
    "Other",
  ]);
  const [checkedValue, setCheckedValue] = useState();
  const [otherReason, setOtherReason] = useState("");
  const [error, setError] = useState(false);
  const { id: eventId } = useParams();

  const { sendRequest: cancelEvent, isLoading } = useApiHttp();
  const handleSubmit = () => {
    if (!checkedValue || (checkedValue === "Other" && !otherReason)) {
      setError(true);
    } else {
      cancelEvent(
        {
          url: "event/cancel-event",
          method: "POST",
          body: {
            id: eventId,
            cancelComment:
              checkedValue === "Other" ? otherReason : checkedValue,
          },
        },
        (data) => {
          navigate("/home");
          closeModal();
        }
      );
    }
  };
  return (
    <Container
      direction="column"
      gap={32}
      fullWidth
      horizontalAlign="center"
      paddingLeft={40}
      paddingRight={40}
      style={{ marginTop: "24px" }}
    >
      <form action="" className="column-form" onSubmit={formSubmitHandler}>
        <Text
          text="Reasons for Cancellation"
          appearance="body-m-bold"
          color="primary-grey-80"
        />
        {reasonLabel.map((item) => {
          return (
            <InputRadio
              label={item}
              onClick={(e) => {
                setCheckedValue(item);
              }}
              checked={item === checkedValue ? true : false}
            />
          );
        })}

        {/* <InputCheckbox label="Unexpected Circumstances" value="hello" />
      <InputCheckbox label="Venue Issues" />
      <InputCheckbox label="Low Attendance" />
      <InputCheckbox label="Other" /> */}
        <InputTextarea
          label="Other"
          placeholder="Write something..."
          rows={1}
          disabled={checkedValue !== "Other"}
          onChange={(e) => {
            setOtherReason(e.target.value);
          }}
          onKeyDown={(e) => {
            e.stopPropagation();
          }}
        />
        {error && (
          <p style={{ fontSize: "14px", color: "#660014" }}>
            {checkedValue !== "Other"
              ? "Please selcet the Reason"
              : "Please enter the Reason"}
          </p>
        )}

        {/* <Container
          fullWidth
          horizontalAlign="center"
          style={{ marginTop: "48px" }}
        >
          <Button
            label="Cancel"
            size="large"
            onClick={() => {
              handleSubmit();
            }}
          />
        </Container> */}
        <div style={{ textAlign: "center" }}>
          <Button
            label="Cancel"
            size="large"
            onClick={() => {
              handleSubmit();
            }}
            loading={isLoading}
          />
        </div>
      </form>
    </Container>
  );
}
